import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { CartProvider } from "@/context/CartContext";
import CartDrawer from "@/components/cart/CartDrawer";
import WhatsAppCartButton from "@/components/cart/WhatsAppCartButton";
import ScrollToTop from "@/components/utils/ScrollToTop";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <ScrollToTop />
        <CartProvider>
          <AppRoutes />
          <CartDrawer />
          <WhatsAppCartButton />
        </CartProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
